import { secureGet, securePost, securePut, } from "../../Config/ApiConfig";


export const getUser = async (id) => {
    const { data } = await secureGet('/users/me');
    return data;
};


export const updateUser = async (body) => {
    const { data } = await securePut('/users/me', body);
    return data;
};

export const sendVerificationEmail = async (id, body) => {
    const { data } = await securePost('/users/me/resend-verification-email', body);
    return data;
};